import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const VirtualIconColored: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22" height="22" viewBox="0 0 22 18">
		<g transform="translate(-40 -12.5)">
			<g transform="translate(40 12.5)">
				<path
					d="M9,18a9,9,0,1,1,9-9A9.008,9.008,0,0,1,9,18ZM7.678,5.4a1.286,1.286,0,0,0-.564.131,1.152,1.152,0,0,0-.5.543,5.623,5.623,0,0,0-.161.638A13.717,13.717,0,0,0,6.3,8.995a16.137,16.137,0,0,0,.134,2.215,1,1,0,0,1,.022.1,3.534,3.534,0,0,0,.193.7,1.125,1.125,0,0,0,.993.594h.036a3.011,3.011,0,0,0,.832-.245,13.646,13.646,0,0,0,3.571-2.38l.053-.053a3.5,3.5,0,0,0,.25-.28A1.035,1.035,0,0,0,12.6,9a1.084,1.084,0,0,0-.232-.682l-.059-.062L12.3,8.25l-.011-.012c-.059-.062-.139-.147-.215-.222A13.69,13.69,0,0,0,8.421,5.6a3.123,3.123,0,0,0-.743-.2Z"
					transform="translate(0 0)"
					fill="#39888d"
				/>
			</g>
			<g transform="translate(44 12.5)">
				<path
					d="M9,18a9,9,0,1,1,9-9A9.008,9.008,0,0,1,9,18ZM7.678,5.4a1.286,1.286,0,0,0-.564.131,1.152,1.152,0,0,0-.5.543,5.623,5.623,0,0,0-.161.638A13.717,13.717,0,0,0,6.3,8.995a16.137,16.137,0,0,0,.134,2.215,1,1,0,0,1,.022.1,3.534,3.534,0,0,0,.193.7,1.125,1.125,0,0,0,.993.594h.036a3.011,3.011,0,0,0,.832-.245,13.646,13.646,0,0,0,3.571-2.38l.053-.053a3.5,3.5,0,0,0,.25-.28A1.035,1.035,0,0,0,12.6,9a1.084,1.084,0,0,0-.232-.682l-.059-.062L12.3,8.25l-.011-.012c-.059-.062-.139-.147-.215-.222A13.69,13.69,0,0,0,8.421,5.6a3.123,3.123,0,0,0-.743-.2Z"
					transform="translate(0 0)"
					fill="#7ee7ff"
				/>
				<path
					d="M6.3,3.6a1.037,1.037,0,0,1-.215.639,3.475,3.475,0,0,1-.251.28l-.054.052A13.637,13.637,0,0,1,2.21,6.955a3.127,3.127,0,0,1-.832.245H1.342a1.129,1.129,0,0,1-.993-.594,4.916,4.916,0,0,1-.215-.8A15.866,15.866,0,0,1,0,3.6,13.692,13.692,0,0,1,.152,1.312,5.743,5.743,0,0,1,.313.674a1.148,1.148,0,0,1,.5-.542A1.28,1.28,0,0,1,1.378,0a3.1,3.1,0,0,1,.743.2A13.7,13.7,0,0,1,5.772,2.616c.125.122.26.272.3.306A1.089,1.089,0,0,1,6.3,3.6"
					transform="translate(6.3 5.4)"
					fill="#3a888d"
				/>
			</g>
		</g>
	</svg>
);
